import { Box, Divider } from "@mui/material";
import { DotLegalTextField } from "@dotlegal/dotlegal-ui-components";
import React from "react";
import useContryCurrencyHook from "../../../hooks/useCountryCurrencyList.ts";
import { useTranslation } from "../../../../localization/useTranslation.ts";
import { FilterOption } from "../FilterPopover.types.ts";
import SubMenuList from "./SubMenuList.tsx";
import { TextFieldWrapper } from "../FilterPopover.tsx";
import { GetAmountData } from "./SubMenuDataHelper.ts";

export interface AmountFieldValue {
    currencyCode: string;
    from: number | undefined;
    to: number | undefined;
}

export interface AmountFieldSubMenuProps {
    selectedOption: FilterOption;
    onChange: (value: AmountFieldValue) => void;
    onLeftArrowClick?: () => void;
    submenuInputRef: React.RefObject<HTMLInputElement>;
}

function AmountFieldSubMenu(props: AmountFieldSubMenuProps) {
    const { onChange, onLeftArrowClick, submenuInputRef } = props;
    const { getCurrenciesAsNames } = useContryCurrencyHook();
    const { translateString } = useTranslation();

    const currencies = getCurrenciesAsNames();

    const value = GetAmountData(props.selectedOption.value);

    const onIntervalChange = (from: number | undefined, to: number | undefined) => {
        onChange({ currencyCode: value.currencyCode, from: from, to: to });
    };

    const onCurrencyChange = (currencyCode: string) => {
        if (value.currencyCode === currencyCode) {
            onChange({ currencyCode: "", from: value.from, to: value.to });
        } else {
            onChange({ currencyCode: currencyCode, from: value.from, to: value.to });
        }
    };

    return (
        <Box>
            <TextFieldWrapper>
                <DotLegalTextField
                    label={translateString("from")}
                    value={value.from?.toString() ?? null}
                    debounce={false}
                    onlyNumber={"decimal"}
                    onChange={(from) => onIntervalChange(from ? parseFloat(from) : undefined, value.to)}
                    noMargin
                />
                <DotLegalTextField
                    label={translateString("to")}
                    value={value.to?.toString() ?? null}
                    debounce={false}
                    onlyNumber={"decimal"}
                    onChange={(to) => onIntervalChange(value.from, to ? parseFloat(to) : undefined)}
                    noMargin
                />
            </TextFieldWrapper>

            <Divider />

            <SubMenuList
                submenuInputRef={submenuInputRef}
                data={currencies}
                onChange={(chosenOption) => onCurrencyChange(chosenOption.id)}
                onLeftArrowClick={onLeftArrowClick}
                chosenValues={value.currencyCode ? [currencies.find((x) => x.id == value.currencyCode)!] : []}
            />
        </Box>
    );
}

export default AmountFieldSubMenu;
